import { CSSProperties } from 'react';

export const checklistItemIndexMap: Record<number, number[]> = {
  1: [1, 2, 3],
  2: [4, 5, 6],
  // 3: [7, 8],
  3: [7, 8, 9],
};

export const arrowDirectionMap: Record<string, CSSProperties> = {
  'left-start': { top: '12px', left: '-5px' },
  'right-start': { top: '12px', right: '-5px' },
  'left-end': { bottom: '12px', left: '-5px' },
  'right-end': { bottom: '12px', right: '-5px' },
  'top-start': { left: '12px', top: '-5px' },
  'top-end': { right: '12px', top: '-5px' },
  'bottom-start': { left: '12px', bottom: '-5px' },
  'bottom-end': { right: '12px', bottom: '-5px' },
};
